import React from "react";
import { RespuestaLeerPropietarios } from "../../../services/propietariosServicios";
import { Button, Modal } from "react-bootstrap";
import PropietariosTableSection from "./PropietariosTableSection";

const PropietariosModal = ({
  propietarios,
  seleccionarPropietario,
  mostrar,
  onCerrar,
}: {
  propietarios: RespuestaLeerPropietarios[];
  seleccionarPropietario: (propietario: RespuestaLeerPropietarios) => void;
  mostrar: boolean;
  onCerrar: () => void;
}) => {
  return (
    <Modal show={mostrar} onHide={onCerrar} size="lg">
      <Modal.Body>
        <PropietariosTableSection
          propietarios={propietarios}
          onPropietarioClick={seleccionarPropietario}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCerrar}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PropietariosModal;
